// removed by extract-text-webpack-plugin
module.exports = {"Button":"button__Button__2PlFj","Success":"button__Success__2UiuM","Danger":"button__Danger__M9azn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/button.css
// module id = 146
// module chunks = 3